export default __webpack_public_path__ + "static/media/noimage.2338afbf.png";